import { FileInfo } from './FileInfo';
var ListResultDtoOfFileInfo = /** @class */ (function () {
    function ListResultDtoOfFileInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfFileInfo.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FileInfo.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfFileInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfFileInfo();
        result.init(data);
        return result;
    };
    ListResultDtoOfFileInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    ListResultDtoOfFileInfo.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ListResultDtoOfFileInfo();
        result.init(json);
        return result;
    };
    return ListResultDtoOfFileInfo;
}());
export { ListResultDtoOfFileInfo };
